/*
 * File: query-reload.ts
 * File Created: 2024-09-15 09:12:38
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-17 10:39:38
 * Modified By: Val Liu
 * -----
 */

/// specify this function to apply to query reload.
/// query: the property name of the query. default: "query"
export function queryReload(query: string = "query") {
    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
        const originalMethod = descriptor.value;
        descriptor.value = function (...args: any[]) {
            this[query].reload = originalMethod.bind(this, ...args);
            return originalMethod.apply(this, args);
        };
        return descriptor;
    };
}
